import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _JOB_STATUS_ZH;
export var JOB_STATUS;
(function (JOB_STATUS) {
  JOB_STATUS[JOB_STATUS["ONJOB"] = 1] = "ONJOB";
  JOB_STATUS[JOB_STATUS["RESIGN"] = 0] = "RESIGN";
})(JOB_STATUS || (JOB_STATUS = {}));
export var JOB_STATUS_LIST = [{
  label: '在职',
  value: JOB_STATUS.ONJOB
}, {
  label: '离职',
  value: JOB_STATUS.RESIGN
}];
export var JOB_STATUS_ZH = (_JOB_STATUS_ZH = {}, _defineProperty(_JOB_STATUS_ZH, JOB_STATUS.ONJOB, '在职'), _defineProperty(_JOB_STATUS_ZH, JOB_STATUS.RESIGN, '离职'), _JOB_STATUS_ZH);